import { type CustomerDetails } from '@service-initiation/tech-care-data-access-store';

import { customerDetailsFormSchema } from './schemas';

export const completedCustomerDetails = (
  customerDetails: Partial<CustomerDetails>
): boolean => customerDetailsFormSchema().isValidSync(customerDetails);
